module.exports = __webpack_public_path__ + "fonts/Young-Italic.6005874f.ttf";